/** Shape and predicates for legislation the compliance agent identified.
 *
 *  Kept out of AiLawList.tsx so that file exports only components (react-refresh).
 */

export interface AiLaw {
  jurisdiction?: string;
  instrument?: string;
  article_ref?: string;
  relevance?: string;
  source_clause?: string;
  confidence?: number | null;
  bloc?: string;
  /**
   * corroborated | ai_only | contradicted. Typed as string because it arrives
   * from a stored JSONB blob that may predate any of these values.
   */
  status?: string;
  matrix_instrument?: string;
  /** compliant | non_compliant | unclear — the agent's verdict on this contract. */
  compliance_status?: string;
  /** What the agent says fails, and against which article. */
  breach?: string;
}

/** Whether this law was flagged as breached — drives the senior lock (INV-COMPLY-01). */
export function isBreached(law: AiLaw): boolean {
  return law.compliance_status === 'non_compliant';
}

/** A citation as a reviewer would read it: instrument plus article, when given. */
export function lawCitation(law: AiLaw): string {
  return [law.instrument, law.article_ref].filter(Boolean).join(' ');
}
